<template>
  <!-- <div
    :class="['cms-content', { 'container': sync }]"
    v-if="getCmsData"
    v-html="getCmsData.content"
  /> -->
  <section
    class="cms-block-banners"
    :class="{'m-t_Office': getRootCategorySlug === config.rootcategories.biuro}"
  >
    <no-ssr>
      <carousel
        :per-page="1"
        :navigation-enabled="false"
        :pagination-enabled="true"
        :autoplay-hover-pause="true"
        :autoplay-timeout="8000"
        :speed="1000"
        :autoplay="true"
        :loop="true"
        pagination-active-color="#f26190"
        pagination-color="#ffffff"
        v-if="showCarousel && getBanners().length > 0"
      >
        <slide v-for="(slide, index) in getBanners()" :key="index">
          <a
            class="item"
            :href="slide.link"
            v-lazy:background-image="getImagePath(slide)"
            :title="slide.title"
            :style="getItemStyle()"
          />
        </slide>
      </carousel>
    </no-ssr>
  </section>
</template>

<script>
import config from "config";
import NoSSR from "vue-no-ssr";
import RootCateogry from "theme/mixins/rootCategory";

export default {
  name: "CmsBlockBanner",
  props: {
    identifier: {
      type: String,
      default: null,
      required: true,
    },
    itemHeight: {
      type: Number,
      default: null,
      required: false,
    },
    padding: {
      type: String,
      default: null,
      required: false,
    },
  },
  mixins: [RootCateogry],
  data() {
    return {
      showCarousel: false,
      config
    };
  },
  components: {
    Carousel: () => import("vue-carousel").then((Slider) => Slider.Carousel),
    Slide: () => import("vue-carousel").then((Slider) => Slider.Slide),
    "no-ssr": NoSSR,
  },
  computed: {
    bannerData() {
      if (this.identifier) {
        let __response = this.$store.getters[`cmsBlock/cmsBlockIdentifier`](
          this.identifier
        );
        if (__response) {
          return JSON.parse(__response.content);
        }
      }
      return [];
    },
  },
  async mounted() {
    await this.$store.dispatch("cmsBlock/single", {
      key: "identifier",
      value: this.identifier,
    });
    this.showCarousel = true;
  },
  methods: {
    getItemStyle() {
      let style = "";
      if (this.itemHeight !== null) {
        style = "height: " + this.itemHeight + "px";
      }
      if (this.padding !== null) {
        style = "padding-top: " + this.padding;
        style = style + "; height: auto;";
      }
      return style;
    },
    getImagePath(slide) {
      const {image, imageRelative} = slide;
      const {url} = config.cmsB2B.banners;
      // if (imageRelative) {
      //   return `${url}${imageRelative}`;
      // }
      return image;
    },
    getBanners() {
      if (this.bannerData === null) {
        return [];
      }
      if (typeof this.bannerData.items === "undefined") {
        return [];
      }
      let _items = this.bannerData.items.filter((e) => {
        if (typeof e.categorySlug === "undefined") {
          return true;
        } else if (e.categorySlug !== this.getRootCategorySlug) {
          return false;
        }
        return true;
      });
      if (_items.length > 0) {
        if (this.bannerData.isRandom === "true") {
          let items = [];
          items.push(_items[Math.floor(Math.random() * _items.length)]);
          return items;
        }
        return _items;
      }
      return [];
    },
  },
};
</script>
<style lang="scss">
.cms-block-banners {
  margin-bottom: 30px;
  .VueCarousel {
    .VueCarousel-wrapper {
      border-radius: 30px;

      .VueCarousel-inner {
        .VueCarousel-slide {
          .item {
            height: 200px;
            width: 100%;
            display: block;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            border-radius: 30px;
            @media (max-width: 1400px) {
              height: 200px;
              background-size: cover;
              background-position: bottom;
              background-repeat: no-repeat;
            }

            &:hover::after {
              background-color: transparent !important;
            }
          }
        }
      }
    }
    &-pagination {
      position: absolute;
      top: 8px;
      right: 13px;
      display: inline-block;
      width: auto !important;
    }
    &-dot {
      margin-top: 0px !important;
      padding: 5px !important;
    }
    &-dot--active {
      .VueCarousel-dot-button {
        background: #0b5ca2 !important;
      }
    }
    &-dot-button {
      width: 15px !important;
      height: 15px !important;
      background: #fff !important;
      box-shadow: 0 0 12px 7px rgba(0, 0, 0, 0.1);
    }
  }
}
.m-t_Office {
  margin-top: 30px;
}

.details_office-banner {
  @media(max-width: 576px) {
    display: none
  }
  .item {
    @media(max-width: 1540px) {
      height: 272px !important;
    }
    @media(max-width: 1200px) {
      height: 230px !important;
    }
    @media(max-width: 992px) {
      height: 166px !important;
    }
    @media(max-width: 768px) {
      height: 160px !important;
    }
  }
}
</style>
